<div
  class="step-separator"
  [ngClass]="{ pointer: (isBeforeCurrent$ | async) }"
  (click)="onGoToStep()"
  [id]="'compatibilityStep' + step"
>
  <div class="badge" [class.current]="isCurrent">
    <span class="badge-content">{{ step }}</span>
  </div>
  <div class="row" [class.current]="isCurrent"></div>
</div>
